<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" :data="clubIntoRecordList.beanList" :row-key="(row)=>row.randomId+row.time" height="100%">
                <el-table-column label="俱乐部" min-width="180" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="randomId"/>
                <el-table-column label="德州池" align="center" prop="dzPool"/>
                <el-table-column label="奥马哈池" align="center" prop="omahaPool"/>
                <el-table-column label="AOF池" align="center" prop="aofPool"/>
                <el-table-column label="贡献人数" align="center" prop="totalPeopleNum"/>
                <el-table-column label="贡献次数" align="center" prop="totalTime"/>
                <el-table-column label="贡献总数额" align="center" prop="totalAmout"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="clubIntoRecordList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>

</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed:{
            ...mapState('jackpot',['clubIntoRecordList'])
        },
        methods: {
            ...mapActions('jackpot', ['getClubIntoRecord']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getClubIntoRecord(page).then(()=>{
                    this.loading = false;
                })
            }
        }
    }
</script>
<style lang="scss" scoped>

</style>